import React from 'react';

// Renders text with **bold**, line breaks, and @mentions highlighted.
export default function RichText({ text, className = '' }) {
  if (!text) return null;
  const lines = text.split('\n');
  return (
    <span className={className}>
      {lines.map((line, li) => (
        <React.Fragment key={li}>
          {renderLine(line)}
          {li < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </span>
  );
}

function renderLine(line) {
  // Split by bold **...** first
  const parts = line.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i} className="font-semibold text-[#0E1726]">{renderMentions(part.slice(2, -2))}</strong>;
    }
    return <React.Fragment key={i}>{renderMentions(part)}</React.Fragment>;
  });
}

function renderMentions(text) {
  const tokens = text.split(/(@[A-Za-z0-9_.]+)/g);
  return tokens.map((t, i) =>
    t.startsWith('@') ? (
      <span key={i} className="text-[#2E6BFF] font-semibold">{t}</span>
    ) : (
      <React.Fragment key={i}>{t}</React.Fragment>
    )
  );
}
